export default "__VITE_ASSET__1dcda6cd__"